import { render, staticRenderFns } from "./scheduleDetail_baseInfor.vue?vue&type=template&id=7f844356&scoped=true"
import script from "./scheduleDetail_baseInfor.vue?vue&type=script&lang=js"
export * from "./scheduleDetail_baseInfor.vue?vue&type=script&lang=js"
import style0 from "./scheduleDetail_baseInfor.vue?vue&type=style&index=0&id=7f844356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f844356",
  null
  
)

export default component.exports